import { StreamingUgcPlatform } from 'fym-shared/src/music24/streamingSections';

/** The platform names and marks (design streaming-sections c1). Brand names, so they are not translated. */
export const UGC_PLATFORM_LOOKS: Record<StreamingUgcPlatform, { code: string; name: string; shortName: string }> = {
  tiktok: { code: 'TT', name: 'TikTok', shortName: 'TikTok' },
  meta: { code: 'M', name: 'Meta (Instagram, Facebook)', shortName: 'Meta' },
  youtubeShorts: { code: 'YT', name: 'YouTube Shorts', shortName: 'YouTube Shorts' },
  douyin: { code: 'DY', name: 'Douyin', shortName: 'Douyin' },
};

/** True when the text is a platform of the contract (a `?platform=` value from the address). */
export function isUgcPlatform(value: string | undefined): value is StreamingUgcPlatform {
  return value !== undefined && Object.prototype.hasOwnProperty.call(UGC_PLATFORM_LOOKS, value);
}
